export default "__VITE_ASSET__BTokDoRV__"